import { useEffect, useState } from "react";

import { AnalyseGraph } from "../AnalyseGraph";

import { Box, Grid } from "@mui/material";
import { ANALYSES_TYPES } from "constants/common.constants";

export const AnalyseGraphsContent = ({
  currentAnalyse,
  data,
  analysisType,
  independent = false,
  currentTab,
  setHasNotCreatedGraphs,
  graphLoading,
}) => {
  const [tabs, setTabs] = useState([]);
  const compareTabTypes = [
    ANALYSES_TYPES.DEPENDENT,
    ANALYSES_TYPES.COMPARE_GROUPS,
    ANALYSES_TYPES.MULTIVARIATE_SINGLE,
    ANALYSES_TYPES.MIXED_MODEL_SINGLE,
    ANALYSES_TYPES.TREE_ANALYSIS,
    ANALYSES_TYPES.SURVIVAL,
  ];

  useEffect(() => {
    if (data) {
      if (compareTabTypes.includes(analysisType))
        setTabs(
          createCompareGroupsTabs({
            data,
            tab: currentTab,
            currentAnalyse,
            setHasNotCreatedGraphs,
            graphLoading,
          })
        );

      if (analysisType === ANALYSES_TYPES.CORRELATIONS)
        setTabs(createCorrelationsTabs({ data, currentAnalyse, setHasNotCreatedGraphs, graphLoading }));
      if (analysisType === ANALYSES_TYPES.FREQUENCY_TABLES)
        setTabs(createFrequencyTabs({ data, currentAnalyse, setHasNotCreatedGraphs, graphLoading }));

      if (analysisType === ANALYSES_TYPES.MIXED_MULTIVARIATE || analysisType === ANALYSES_TYPES.MULTIVARIATE)
        setTabs(
          createMultivariateGraphs({
            data,
            independent,
            currentAnalyse,
            setHasNotCreatedGraphs,
            graphLoading,
          })
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, independent, currentTab, graphLoading]);

  return (
    !!tabs.length && (
      <Grid
        sx={{
          p: "12px",
          maxHeight: "550px",
          overflowY: "auto",
          backgroundColor: "#F9FAFB",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box>{tabs}</Box>
      </Grid>
    )
  );
};

const createMultivariateGraphs = ({
  data,
  independent,
  currentAnalyse,
  setHasNotCreatedGraphs,
  graphLoading,
}) => {
  let multivariateTabs = [];
  if (data?.all) {
    let keys = Object.keys(data.all.all_models);
    if (independent) {
      multivariateTabs.push(
        <AnalyseGraph
          data={data.all.main_independents}
          key={keys[0]}
          {...{ setHasNotCreatedGraphs, currentAnalyse, graphLoading }}
        />
      );
    } else {
      keys.forEach((key, index) => {
        console.log(key);
        multivariateTabs.push(
          <AnalyseGraph
            routeKey={key}
            data={data.all.all_models[key]}
            key={index}
            {...{ setHasNotCreatedGraphs, currentAnalyse, graphLoading }}
          />
        );
      });
    }
  } else {
    let keys = Object.keys(data);
    keys.forEach((key, index) => {
      let keys2 = Object.keys(data[key].all_models);
      if (independent) {
        multivariateTabs.push(
          <AnalyseGraph
            data={data[key].main_independents}
            key={index}
            {...{ setHasNotCreatedGraphs, currentAnalyse, graphLoading }}
          />
        );
      } else {
        keys2.forEach((key2, index2) => {
          multivariateTabs.push(
            <AnalyseGraph
              routeKey={key2}
              data={data[key].all_models[key2]}
              key={index2}
              {...{ setHasNotCreatedGraphs, currentAnalyse, graphLoading }}
            />
          );
        });
      }
    });
  }
  return multivariateTabs;
};

const createCorrelationsTabs = ({ data, currentAnalyse, setHasNotCreatedGraphs, graphLoading }) => {
  let tabs = [];
  if (data?.null) {
    return null;
  } else {
    let keys = Object.keys(data);
    keys.forEach((key) => {
      let keys2 = Object.keys(data[key]);
      keys2.forEach((key2, index) => {
        tabs.push(
          <AnalyseGraph
            key={index}
            routeKey={key2 !== "heatmap" ? key2 : "heatmap"}
            currentAnalyse={currentAnalyse}
            data={key2 !== "heatmap" ? data[key][key2] : { heatmap: data[key].heatmap }}
            {...{ setHasNotCreatedGraphs, currentAnalyse, graphLoading }}
          />
        );
      });
    });
  }
  return tabs;
};

const createFrequencyTabs = ({ data, currentAnalyse, setHasNotCreatedGraphs, graphLoading }) => {
  let tabs = [];
  if (data?.null) {
    return null;
  } else {
    tabs.push(
      <AnalyseGraph
        currentAnalyse={currentAnalyse}
        data={data?.all?.main_independents}
        {...{ setHasNotCreatedGraphs, currentAnalyse, graphLoading }}
      />
    );
  }
  return tabs;
};

const createCompareGroupsTabs = ({ data, tab, currentAnalyse, setHasNotCreatedGraphs, graphLoading }) => {
  let tabs = [];
  const routeKey = tab !== "heatmap" ? tab : "heatmap";
  if (data?.null) {
    return (
      <AnalyseGraph
        routeKey={routeKey}
        data={tab !== "heatmap" ? data.all[tab] : { heatmap: data.all.heatmap }}
        {...{ setHasNotCreatedGraphs, currentAnalyse, graphLoading }}
      />
    );
  } else {
    let keys = Object.keys(data);

    keys.forEach((key, index) => {
      tabs.push(
        <AnalyseGraph
          currentAnalyse={currentAnalyse}
          key={index}
          routeKey={routeKey}
          data={tab !== "heatmap" ? data[key][tab] : { heatmap: data[key].heatmap }}
          {...{ setHasNotCreatedGraphs, currentAnalyse, graphLoading }}
        />
      );
    });
  }
  return tabs;
};
